const searchbarEls = document.querySelectorAll(".searchbar");

try {
  searchbarEls.forEach((searchbarEl) => {
    const btnEl = searchbarEl.querySelector("button");
    const inputEl = searchbarEl.querySelector("form input");

    if (btnEl && inputEl) {
      document.addEventListener("click", (e) => {
        const isActive = searchbarEl.classList.contains("active");
        const btnElClicked = e.target === btnEl || btnEl.contains(e.target);
        const inputElClicked = e.target === inputEl || inputEl.contains(e.target);

        if (!isActive && btnElClicked) {
          searchbarEl.classList.add("active");
          inputEl.focus();
        } else if (!inputElClicked) {
          searchbarEl.classList.remove("active");
        }
      });
    }
  });
} catch (error) {
  console.log(error);
}
